
import { AIAgent } from '@/types/aiAgents';

export const AGENT_ICONS = {
  weather: 'https://cdn-icons-png.flaticon.com/512/1163/1163661.png',
  news: 'https://cdn-icons-png.flaticon.com/512/3208/3208799.png',
  currency: 'https://cdn-icons-png.flaticon.com/512/2991/2991110.png',
  wikipedia: 'https://cdn-icons-png.flaticon.com/512/732/732221.png',
  giphy: 'https://cdn-icons-png.flaticon.com/512/5968/5968705.png',
  meme: 'https://cdn-icons-png.flaticon.com/512/1532/1532555.png',
  recipe: 'https://cdn-icons-png.flaticon.com/512/1147/1147303.png',
  youtube: 'https://cdn-icons-png.flaticon.com/512/1384/1384060.png',
  calculator: 'https://cdn-icons-png.flaticon.com/512/1828/1828774.png',
  'qr-code': 'https://cdn-icons-png.flaticon.com/512/714/714392.png',
  'color-palette': 'https://cdn-icons-png.flaticon.com/512/3412/3412476.png',
  'pdf-generator': 'https://cdn-icons-png.flaticon.com/512/337/337946.png',
  'pixabay-search': 'https://cdn-icons-png.flaticon.com/512/1829/1829586.png',
  'unsplash-search': 'https://cdn-icons-png.flaticon.com/512/174/174857.png',
  'search': 'https://cdn-icons-png.flaticon.com/512/751/751463.png',
  'image-search': 'https://cdn-icons-png.flaticon.com/512/1829/1829586.png',
  'gmail': 'https://cdn-icons-png.flaticon.com/512/732/732200.png',
  'web-action': 'https://cdn-icons-png.flaticon.com/512/1006/1006771.png',
  'flow': 'https://cdn-icons-png.flaticon.com/512/2920/2920277.png',
  'vgen': 'https://cdn3d.iconscout.com/3d/premium/thumb/ai-video-3d-icon-png-download-9031813.png'
};

export const aiAgents: AIAgent[] = [
  {
    id: 'weather',
    name: 'Weather',
    description: 'Get current weather information for any location',
    icon: AGENT_ICONS.weather,
    category: 'utility'
  },
  {
    id: 'news',
    name: 'News',
    description: 'Get latest news headlines and articles',
    icon: AGENT_ICONS.news,
    category: 'information'
  },
  {
    id: 'wikipedia',
    name: 'Wikipedia',
    description: 'Search and get information from Wikipedia',
    icon: AGENT_ICONS.wikipedia,
    category: 'information'
  },
  {
    id: 'giphy',
    name: 'GIF Search',
    description: 'Find and share animated GIFs from Giphy',
    icon: AGENT_ICONS.giphy,
    category: 'entertainment'
  },
  {
    id: 'meme',
    name: 'Meme Generator',
    description: 'Create custom memes with popular templates',
    icon: AGENT_ICONS.meme,
    category: 'entertainment'  
  },
  {
    id: 'recipe',
    name: 'Recipe Finder',
    description: 'Find recipes and cooking instructions',
    icon: AGENT_ICONS.recipe,
    category: 'lifestyle'
  },
  {
    id: 'youtube',
    name: 'YouTube Search',
    description: 'Search for YouTube videos and channels',
    icon: AGENT_ICONS.youtube,
    category: 'entertainment'
  },
  {
    id: 'calculator',
    name: 'Calculator',
    description: 'Perform mathematical calculations and solve equations',
    icon: AGENT_ICONS.calculator,
    category: 'utility'
  },
  {
    id: 'translator',
    name: 'Translator',
    description: 'Translate text between languages with high accuracy',
    icon: AGENT_ICONS.search,
    category: 'utility'
  },
  {
    id: 'code-explain',
    name: 'Code Explain',
    description: 'Explain code snippets and suggest improvements',
    icon: AGENT_ICONS['image-search'],
    category: 'developer'
  },
  {
    id: 'qr-code',
    name: 'QR Code Generator',
    description: 'Generate QR codes for text, URLs, and more',
    icon: AGENT_ICONS['qr-code'],
    category: 'utility'
  },
  {
    id: 'color-palette',
    name: 'Color Palette',
    description: 'Generate beautiful color palettes for design',
    icon: AGENT_ICONS['color-palette'],
    category: 'design'
  },
  {
    id: 'pdf-generator',
    name: 'PDF Generator',
    description: 'Generate well-formatted PDF documents from text content',
    icon: AGENT_ICONS['pdf-generator'],
    category: 'utility'
  },
  {
    id: 'pixabay-search',
    name: 'Pixabay Images',
    description: 'Search for high-quality images from Pixabay',
    icon: AGENT_ICONS['pixabay-search'],
    category: 'utility'
  },
  {
    id: 'unsplash-search',
    name: 'Unsplash Images',
    description: 'Search for professional photos from Unsplash',
    icon: AGENT_ICONS['unsplash-search'],
    category: 'utility'
  },
  {
    id: 'search',
    name: 'Web Search',
    description: 'Search the web with Google Custom Search and website screenshots',
    icon: AGENT_ICONS['search'],
    category: 'information'
  },
  {
    id: 'image-search',
    name: 'Google Image Search',
    description: 'Search for images using Google Custom Search with high-quality results',
    icon: AGENT_ICONS['image-search'],
    category: 'information'
  },
  {
    id: 'gmail',
    name: 'Gmail Agent',
    description: 'Automate email tasks with Gmail integration',
    icon: AGENT_ICONS['gmail'],
    category: 'automation'
  },
  {
    id: 'web-action',
    name: 'Web Action Agent',
    description: 'Automate web browsing and interactions',
    icon: AGENT_ICONS['web-action'],
    category: 'automation'
  },
  {
    id: 'flow',
    name: 'FlowChart Generator',
    description: 'Create interactive flowcharts and diagrams',
    icon: AGENT_ICONS['flow'],
    category: 'developer'
  }
  ,
  {
    id: 'vgen',
    name: 'vGen (HeyGen)',
    description: 'Generate avatar videos',
    icon: AGENT_ICONS['vgen'],
    category: 'entertainment'
  }
];
